/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetOffeneBuchungsaenderungsAntraegeCount$Json$Params {

/**
 * ob nur für Monteursbuchungen die offenen Buchungsaenderungsantraege geholt werden sollen
 */
  withoutMonteure?: boolean;
}

export function getOffeneBuchungsaenderungsAntraegeCount$Json(http: HttpClient, rootUrl: string, params?: GetOffeneBuchungsaenderungsAntraegeCount$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, getOffeneBuchungsaenderungsAntraegeCount$Json.PATH, 'get');
  if (params) {
    rb.query('withoutMonteure', params.withoutMonteure, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

getOffeneBuchungsaenderungsAntraegeCount$Json.PATH = '/v1/aenderungsAntraege/offen/count';
